// Partner Actions
export const FETCH_PARTNERS_REQUEST = 'FETCH_PARTNERS_REQUEST';
export const FETCH_PARTNERS_SUCCESS = 'FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAILURE = 'FETCH_PARTNERS_FAILURE';

export const FETCH_PARTNER_BY_ID_REQUEST = 'FETCH_PARTNER_BY_ID_REQUEST';
export const FETCH_PARTNER_BY_ID_SUCCESS = 'FETCH_PARTNER_BY_ID_SUCCESS';
export const FETCH_PARTNER_BY_ID_FAILURE = 'FETCH_PARTNER_BY_ID_FAILURE';

export const CREATE_PARTNER_REQUEST = 'CREATE_PARTNER_REQUEST';
export const CREATE_PARTNER_SUCCESS = 'CREATE_PARTNER_SUCCESS';
export const CREATE_PARTNER_FAILURE = 'CREATE_PARTNER_FAILURE';
export const RESET_CREATE_PARTNER = 'RESET_CREATE_PARTNER';

export const UPDATE_PARTNER_REQUEST = 'UPDATE_PARTNER_REQUEST';
export const UPDATE_PARTNER_SUCCESS = 'UPDATE_PARTNER_SUCCESS';
export const UPDATE_PARTNER_FAILURE = 'UPDATE_PARTNER_FAILURE';
export const RESET_UPDATE_PARTNER = 'RESET_UPDATE_PARTNER';

export const DELETE_PARTNER_REQUEST = 'DELETE_PARTNER_REQUEST';
export const DELETE_PARTNER_SUCCESS = 'DELETE_PARTNER_SUCCESS';
export const DELETE_PARTNER_FAILURE = 'DELETE_PARTNER_FAILURE';

export const CREATE_PARTNER_ACCOUNT_REQUEST = 'CREATE_PARTNER_ACCOUNT_REQUEST';
export const CREATE_PARTNER_ACCOUNT_SUCCESS = 'CREATE_PARTNER_ACCOUNT_SUCCESS';
export const CREATE_PARTNER_ACCOUNT_FAILURE = 'CREATE_PARTNER_ACCOUNT_FAILURE';

// Action Creators
export const fetchPartnersRequest = (params = {}) => ({
    type: FETCH_PARTNERS_REQUEST,
    payload: params,
});

export const fetchPartnersSuccess = (data) => ({
    type: FETCH_PARTNERS_SUCCESS,
    payload: data,
});

export const fetchPartnersFailure = (error) => ({
    type: FETCH_PARTNERS_FAILURE,
    payload: error,
});

export const fetchPartnerByIdRequest = (partnerId) => ({
    type: FETCH_PARTNER_BY_ID_REQUEST,
    payload: partnerId,
});

export const fetchPartnerByIdSuccess = (data) => ({
    type: FETCH_PARTNER_BY_ID_SUCCESS,
    payload: data,
});

export const fetchPartnerByIdFailure = (error) => ({
    type: FETCH_PARTNER_BY_ID_FAILURE,
    payload: error,
});

export const createPartnerRequest = (partnerData) => ({
    type: CREATE_PARTNER_REQUEST,
    payload: partnerData,
});

export const createPartnerSuccess = (data) => ({
    type: CREATE_PARTNER_SUCCESS,
    payload: data,
});

export const createPartnerFailure = (error) => ({
    type: CREATE_PARTNER_FAILURE,
    payload: error,
});

export const resetCreatePartner = () => ({
    type: RESET_CREATE_PARTNER,
});

export const updatePartnerRequest = (partnerId, partnerData) => ({
    type: UPDATE_PARTNER_REQUEST,
    payload: { partnerId, partnerData },
});

export const updatePartnerSuccess = (data) => ({
    type: UPDATE_PARTNER_SUCCESS,
    payload: data,
});

export const updatePartnerFailure = (error) => ({
    type: UPDATE_PARTNER_FAILURE,
    payload: error,
});

export const resetUpdatePartner = () => ({
    type: RESET_UPDATE_PARTNER,
});

export const createPartnerAccountRequest = (accountData) => ({
    type: CREATE_PARTNER_ACCOUNT_REQUEST,
    payload: accountData,
});

export const createPartnerAccountSuccess = (data) => ({
    type: CREATE_PARTNER_ACCOUNT_SUCCESS,
    payload: data,
});

export const createPartnerAccountFailure = (error) => ({
    type: CREATE_PARTNER_ACCOUNT_FAILURE,
    payload: error,
});

export const deletePartnerRequest = (partnerId) => ({
    type: DELETE_PARTNER_REQUEST,
    payload: partnerId,
});

export const deletePartnerSuccess = (data) => ({
    type: DELETE_PARTNER_SUCCESS,
    payload: data,
});

export const deletePartnerFailure = (error) => ({
    type: DELETE_PARTNER_FAILURE,
    payload: error,
});

